<div>
    <app-mentornavbar></app-mentornavbar>
</div>
<div class="body">
    <div class="heads">
        <h1>Featured Mentors</h1>
    </div>
    <div class="tabs">
        <button class="btn btn-lg inverse" (click)="switchtab(1)">{{sector1name}}</button>
        <button class="btn btn-lg inverse" (click)="switchtab(2)" *ngIf="!sectorsame">{{sector2name}}</button>
    </div>
    <div class="mentors" *ngIf="sector1">
        <div class="mentortab" *ngFor="let mentor of mentorlist1">
            <div class="profileimg">
                <img src={{mentor.profile_img}} alt="">
            </div>
            <div class="profiledet">
                <h2>{{mentor.mentor_id}}</h2>
                <h2>{{mentor.name}}</h2>
                <!-- <h2>{{mentor.designation}}</h2> -->
                <p>{{mentor.expertise}}</p>
                <a [routerLink]="['/mentor', mentor.mentor_id]"><button class="btn btn-lg inverse">View Profile</button></a>
            </div>
        </div>
    </div>
    <div class="mentors" *ngIf="sector2">
        <div class="mentortab" *ngFor="let mentor of mentorlist2">
            <div class="profileimg">
                <img src={{mentor.profile_img}} alt="">
            </div>
            <div class="profiledet">
                <h2>{{mentor.mentor_id}}</h2>
                <h2>{{mentor.name}}</h2>
                <!-- <h2>{{mentor.designation}}</h2> -->
                <p>{{mentor.expertise}}</p>
                <button class="btn btn-lg inverse">View Profile</button>
            </div>
        </div>
    </div>
</div>